/*
 * - Definitions for file storage queries
 */

import FileStorageService from './service';
import { GetUserFilesDetailsPayload } from './types';

export const FILE_STORAGE_QUERY_KEYS = {
  GET_USER_FILE_DETAILS: 'GET_USER_FILE_DETAILS',
};

export class FileStorageQueries {
  public static readonly getUserFilesDetails = async (params: GetUserFilesDetailsPayload): Promise<any> => {
    const data = await FileStorageService.getUserFilesDetails(params);

    return data;
  };
}
